import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d0e42f14"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSplitter" }, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1))
const _hoisted_3 = {
  key: 0,
  style: {"display":"flex","flex-direction":"column","justify-content":"center","align-items":"center","width":"100%","gap":"1em"}
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "DialogHeaderButton" }, "Select Month", -1))
const _hoisted_5 = { style: {"display":"grid","grid-template-columns":"1fr 1fr 1fr 1fr","gap":"1em"} }
const _hoisted_6 = {
  key: 1,
  style: {"display":"flex","flex-direction":"column","justify-content":"center","align-items":"center","width":"100%","gap":"1em"}
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "DialogHeaderButton" }, "Select Day", -1))
const _hoisted_8 = { style: {"display":"grid","grid-template-columns":"1fr 1fr 1fr 1fr 1fr 1fr 1fr","gap":"1em"} }
const _hoisted_9 = {
  key: 2,
  style: {"display":"flex","flex-direction":"column","justify-content":"center","align-items":"center","width":"100%","gap":"1em"}
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "DialogHeaderButton" }, "Select Day", -1))
const _hoisted_11 = { style: {"display":"grid","grid-template-columns":"1fr 1fr 1fr","gap":"1em"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CookiesDropInputObject = _resolveComponent("CookiesDropInputObject")!
  const _component_CookiesCheckBox = _resolveComponent("CookiesCheckBox")!
  const _component_CookiesDropDown = _resolveComponent("CookiesDropDown")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_CookiesDropInputObject, {
      Name: _ctx.Translate('Calendar Type'),
      Default: '',
      RowHeight: '3em',
      Options: _ctx.CalendarTypes,
      Selectors: ['Name'],
      CookiesInvalidInput: !_ctx.MEMRead(`${_ctx.Res}_Type`) && _ctx.MEMRead(`${_ctx.Res}_Type`) === '',
      ErrorData: _ctx.ErrorsVisibilty && (!_ctx.MEMRead(`${_ctx.Res}_Type`) && _ctx.MEMRead(`${_ctx.Res}_Type`) === ''),
      Res: `${_ctx.Res}_Type`
    }, null, 8, ["Name", "Options", "CookiesInvalidInput", "ErrorData", "Res"]),
    _hoisted_1,
    _hoisted_2,
    (_ctx.MEMRead(`${_ctx.Res}_Type`) === 'Yearly')
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.MonthsOfYear, (month, index) => {
              return (_openBlock(), _createElementBlock("div", {
                style: {"display":"flex","justify-content":"center","align-items":"center"},
                key: index
              }, [
                _createVNode(_component_CookiesCheckBox, {
                  Res: `${_ctx.Res}_MonthsOfYear_${index}`
                }, null, 8, ["Res"]),
                _createTextVNode(" " + _toDisplayString(month), 1)
              ]))
            }), 128))
          ]),
          _createVNode(_component_CookiesDropDown, {
            Radio: true,
            Name: _ctx.Translate('Select Day '),
            Width: '40%',
            style: {"max-width":"80%"},
            Res: `${_ctx.Res}_DaysOfYear`,
            Options: _ctx.DaysOfMonth
          }, null, 8, ["Name", "Res", "Options"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.MEMRead(`${_ctx.Res}_Type`) === 'Monthly')
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.DaysOfMonth, (day, index) => {
              return (_openBlock(), _createElementBlock("div", {
                style: {"display":"flex","justify-content":"center","align-items":"center"},
                key: index
              }, [
                _createVNode(_component_CookiesCheckBox, {
                  Res: `${_ctx.Res}_DaysOfMonth_${index}`
                }, null, 8, ["Res"]),
                _createTextVNode(" " + _toDisplayString(day), 1)
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.MEMRead(`${_ctx.Res}_Type`) === 'Weekly')
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.DaysOfWeek, (day, index) => {
              return (_openBlock(), _createElementBlock("div", {
                style: {"display":"flex","justify-content":"center","align-items":"center"},
                key: index
              }, [
                _createVNode(_component_CookiesCheckBox, {
                  Res: `${_ctx.Res}_DaysOfWeek_${index}`
                }, null, 8, ["Res"]),
                _createTextVNode(" " + _toDisplayString(day), 1)
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}